import React, { useState, useEffect } from 'react';
import CancellationTable from './CancellationTable';
import axiosInstance from 'pages/Utility/axiosInstance';
import Breadcrumb from 'components/Common/Breadcrumb2';

const CancellationList = () => {
    const [cancellationOrders, setCancellationOrders] = useState()
    const [loading, setLoading] = useState(false);

    const fetchCancellationOrders = async () => {
        try {
            setLoading(true)
            const response = await axiosInstance.get('', { params: { sp: "usp_GetPendingWorkOrderCancellation" } });
            setCancellationOrders(response?.data?.Data)
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (loading) return;
        fetchCancellationOrders();
    }, [])

    return (
        <>
            <div className="page-content container-fluid">
                <div className="d-flex justify-content-between align-items-center ms-3">
                    <Breadcrumb title="Cancellations" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Cancellations", link: '#' }]} />
                </div>
                <CancellationTable
                    List={cancellationOrders}
                    loading={loading}
                    fetchCancellationOrders={fetchCancellationOrders}
                />
            </div>
        </>
    );
};

export default CancellationList;
